import type { ShardSummary } from "../../types";
import { formatNumber } from "../../utils/formatters";
import { MatchRateBadge } from "../MatchRateBadge/MatchRateBadge";
import { StatusDistributionBar } from "../StatusDistributionBar/StatusDistributionBar";
import styles from "./ShardBreakdown.module.css";

export interface ShardBreakdownProps {
  shards: ShardSummary[];
}

function StatusBadge({ status }: { status: ShardSummary["status"] }) {
  return (
    <span className={`${styles.statusBadge} ${styles[status]}`}>
      {status}
    </span>
  );
}

export function ShardBreakdown({ shards }: ShardBreakdownProps) {
  if (shards.length === 0) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="shard-breakdown">
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.headerCell}>Shard ID</th>
            <th className={styles.headerCell}>Status</th>
            <th className={styles.headerCell}>Progress</th>
            <th className={styles.headerCell}>Match Rate</th>
            <th className={styles.headerCellWide}>Distribution</th>
          </tr>
        </thead>
        <tbody>
          {shards.map((shard) => (
            <tr key={shard.shard_id} data-testid="shard-row">
              <td className={styles.cell}>
                <span className={styles.shardId} title={shard.shard_id}>
                  {shard.shard_id.slice(0, 8)}
                </span>
              </td>
              <td className={styles.cell}>
                <StatusBadge status={shard.status} />
              </td>
              <td className={styles.cellNumeric}>
                {formatNumber(shard.processed_packets)}/
                {formatNumber(shard.total_packets)}
              </td>
              <td className={styles.cell}>
                <MatchRateBadge rate={shard.match_rate} />
              </td>
              <td className={styles.cellDistribution}>
                <StatusDistributionBar breakdown={shard.status_breakdown} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
